export default __webpack_public_path__ + "fonts/Circular-Bold.woff2";